import { z } from 'zod';
import { ON_OFF } from './helpers/enums.ts';

export const statsLighthouseMetricsSchema = z.enum([...ON_OFF, '']);
